var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 38,
    stroke: "#359EF3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1802 51.4998L24.0219 40.744C22.8369 39.4893 20.8591 39.4328 19.6043 40.6178C18.3496 41.8028 18.2931 43.7807 19.4781 45.0354L31.9781 58.2707C33.237 59.6036 35.3676 59.5715 36.5856 58.2011L61.5856 30.0762C62.7322 28.7862 62.6161 26.811 61.3261 25.6644C60.0362 24.5178 58.0609 24.634 56.9143 25.9239L34.1802 51.4998Z",
    fill: "#359EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircle);
export default __webpack_public_path__ + "static/media/right-circle.e27e2017e3d174fd5e902a9cb3fa0431.svg";
export { ForwardRef as ReactComponent };